//imports
import { all } from 'redux-saga/effects';

//Views
import deviceOverviewSagas from 'Modules/devices/views/overview/redux/saga';
import vidFleetVideoSagas from 'Modules/devices/.components/vidFleetVideo/redux/saga';
import devicesCommonSagas from 'Modules/devices/common/redux/saga';
import bulkPairingSagas from 'Modules/devices/.components/bulkPairing/redux/saga';
import bulkActionsSagas from 'Modules/devices/.components/bulkActions/redux/saga';
import deviceDetailsSagas from 'Modules/devices/views/main/.components/Details/redux/saga';
import activateCameraSimCardSagas from 'Modules/devices/.components/activateSimCard/redux/saga';
import changeSimProviderSagas from 'Modules/devices/.components/changeSimProvider/redux/saga';
import importDevicesSagas from 'Modules/devices/.components/importDevices/redux/saga';

import bulkUnpairingSagas from 'Modules/devices/.components/bulkUnpairing/redux/saga';
import assignFirmwareSagas from 'Modules/devices/.components/assignFirmware/redux/saga';
import simInfoSagas from 'Modules/devices/.components/simInfoTab/redux/saga';
import pulsInfoSagas from 'Modules/devices/.components/pulsInfoTab/redux/saga';
import featureTabSagas from 'Modules/devices/.components/featureTab/redux/saga';
import featureTabUpdateFeatureSagas from 'Modules/devices/.components/featureTab/.components/updateFeature/redux/saga';
import troubleShootingEventsSagas from 'Modules/devices/.components/troubleShootingEventsTab/redux/saga';
import requestDeviceLogSagas from 'Modules/devices/.components/requestDeviceLog/redux/saga';
import formatSDCardSagas from 'Modules/devices/.components/formatSDCard/redux/saga';
import rebootDeviceSagas from 'Modules/devices/.components/rebootDevice/redux/saga';
import associateToGpsSagas from 'Modules/devices/views/overview/.components/associateToGps/redux/saga';
import messagesOutboxTabSagas from 'Modules/devices/.components/messagesOutboxTab/redux/saga';
import editSwapSimCardSagas from 'Modules/devices/.components/editSwapSimCard/redux/saga';
import sendCommandSagas from 'Modules/devices/.components/sendCommand/redux/saga';
import changePulsCustomerSagas from 'Modules/devices/.components/changePulsCustomer/redux/saga';
import changeScriptSagas from 'Modules/devices/.components/changeScript/redux/saga';
import changeStatusSagas from 'Modules/devices/.components/changeStatus/redux/saga';
import moveToOtherAccountSagas from 'Modules/devices/.components/moveToOtherAccount/redux/saga';
import markAsRmaSagas from 'Modules/devices/.components/markAsRma/redux/saga';
import refurbishDeviceSagas from 'Modules/devices/.components/refurbishDevice/redux/saga';
import createEditeNoteSagas from 'Modules/devices/.components/notesTab/.components/createEditNote/redux/saga';
import deleteNoteSagas from 'Modules/devices/.components/notesTab/.components/deleteNote/redux/saga';
import lastReadingSagas from 'Modules/devices/views/main/.components/Details/.components/lastReading/redux/saga';
import revertRmaSagas from 'Modules/devices/.components/revertRma/redux/saga';
import changeTimezoneSagas from 'Modules/devices/.components/changeTimezone/redux/saga';
import dailyDeviceAuditSagas from 'Modules/devices/.components/dailyDeviceAudit/redux/saga';
import coverageDetailsSagas from 'Modules/devices/.components/coverageDetails/redux/saga';
import createDiagnosticDeviceSagas from 'Modules/devices/.components/createDiagnosticDevice/redux/saga';
import createClipRequestSagas from 'Modules/devices/.components/createClipRequest/redux/saga';
import deleteClipRequestSagas from 'Modules/devices/.components/deleteClipRequest/redux/saga';
import clipRequestTabSagas from 'Modules/devices/.components/clipRequestTab/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        deviceOverviewSagas(),
        vidFleetVideoSagas(),
        devicesCommonSagas(),
        bulkPairingSagas(),
        bulkActionsSagas(),
        deviceDetailsSagas(),
        activateCameraSimCardSagas(),
        changeSimProviderSagas(),
        importDevicesSagas(),
        bulkUnpairingSagas(),
        assignFirmwareSagas(),
        simInfoSagas(),
        pulsInfoSagas(),
        featureTabSagas(),
        featureTabUpdateFeatureSagas(),
        troubleShootingEventsSagas(),
        requestDeviceLogSagas(),
        formatSDCardSagas(),
        rebootDeviceSagas(),
        associateToGpsSagas(),
        messagesOutboxTabSagas(),
        editSwapSimCardSagas(),
        sendCommandSagas(),
        changePulsCustomerSagas(),
        changeScriptSagas(),
        changeStatusSagas(),
        moveToOtherAccountSagas(),
        markAsRmaSagas(),
        refurbishDeviceSagas(),
        createEditeNoteSagas(),
        deleteNoteSagas(),
        lastReadingSagas(),
        revertRmaSagas(),
        changeTimezoneSagas(),
        dailyDeviceAuditSagas(),
        coverageDetailsSagas(),
        createDiagnosticDeviceSagas(),
        createClipRequestSagas(),
        deleteClipRequestSagas(),
        clipRequestTabSagas(),
    ]);
}